// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: vBcMyVvohcRf6jTAAhLpUM
// Component: 5PQ7okHXOV

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import TextField from "@material-ui/core/TextField"; // plasmic-import: DRjvwSWP5d/codeComponent
import CircularProgress from "@material-ui/core/CircularProgress"; // plasmic-import: kB17xs_4vh/codeComponent

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_ibeam_access.module.css"; // plasmic-import: vBcMyVvohcRf6jTAAhLpUM/projectcss
import sty from "./PlasmicLoginPage.module.css"; // plasmic-import: 5PQ7okHXOV/css

import imageGemkdHeh9 from "./images/image.png"; // plasmic-import: GemkdHEH9/picture

export type PlasmicLoginPage__VariantMembers = {
  loading: "loading";
};
export type PlasmicLoginPage__VariantsArgs = {
  loading?: SingleBooleanChoiceArg<"loading">;
};
type VariantPropType = keyof PlasmicLoginPage__VariantsArgs;
export const PlasmicLoginPage__VariantProps = new Array<VariantPropType>(
  "loading"
);

export type PlasmicLoginPage__ArgsType = {
  usernameTextField?: React.ReactNode;
  passwordTextField?: React.ReactNode;
};
type ArgPropType = keyof PlasmicLoginPage__ArgsType;
export const PlasmicLoginPage__ArgProps = new Array<ArgPropType>(
  "usernameTextField",
  "passwordTextField"
);

export type PlasmicLoginPage__OverridesType = {
  root?: p.Flex<"div">;
  welcome?: p.Flex<"div">;
  text?: p.Flex<"div">;
  materialUiCircularProgress?: p.Flex<typeof CircularProgress>;
  signInButton?: p.Flex<"button">;
  img?: p.Flex<"img">;
};

export interface DefaultLoginPageProps {
  usernameTextField?: React.ReactNode;
  passwordTextField?: React.ReactNode;
  loading?: SingleBooleanChoiceArg<"loading">;
  className?: string;
}

const __wrapUserFunction =
  globalThis.__PlasmicWrapUserFunction ?? ((loc, fn) => fn());
const __wrapUserPromise =
  globalThis.__PlasmicWrapUserPromise ??
  (async (loc, promise) => {
    return await promise;
  });

function PlasmicLoginPage__RenderFunc(props: {
  variants: PlasmicLoginPage__VariantsArgs;
  args: PlasmicLoginPage__ArgsType;
  overrides: PlasmicLoginPage__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};
  const [$queries, setDollarQueries] = React.useState({});
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "loading",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.loading
      }
    ],
    [$props, $ctx]
  );
  const $state = p.useDollarState(stateSpecs, { $props, $ctx, $queries });

  return (
    <React.Fragment>
      <div
        data-plasmic-name={"root"}
        data-plasmic-override={overrides.root}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          projectcss.all,
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          projectcss.plasmic_tokens,
          sty.root,
          { [sty.rootloading]: hasVariant($state, "loading", "loading") }
        )}
      >
        <p.Stack
          as={"div"}
          hasGap={true}
          className={classNames(projectcss.all, sty.freeBox__nxghs)}
        >
          <div className={classNames(projectcss.all, sty.freeBox__ndtWe)}>
            <div
              data-plasmic-name={"welcome"}
              data-plasmic-override={overrides.welcome}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.welcome
              )}
            >
              {"Welcome"}
            </div>
            <div
              data-plasmic-name={"text"}
              data-plasmic-override={overrides.text}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text
              )}
            >
              {"Sign in to access Ibeam and Spiraline Job Artefacts"}
            </div>
          </div>
          <p.Stack
            as={"div"}
            hasGap={true}
            className={classNames(projectcss.all, sty.freeBox__qun8F, {
              [sty.freeBoxloading__qun8F09Hv2]: hasVariant(
                $state,
                "loading",
                "loading"
              )
            })}
          >
            {(hasVariant($state, "loading", "loading") ? true : true) ? (
              <p.Stack
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.freeBox__e0W28, {
                  [sty.freeBoxloading__e0W2809Hv2]: hasVariant(
                    $state,
                    "loading",
                    "loading"
                  )
                })}
              >
                {p.renderPlasmicSlot({
                  defaultContents: (
                    <TextField
                      className={classNames(
                        "__wab_instance",
                        sty.materialUiTextField___7MwH
                      )}
                      label={"Username" as const}
                    />
                  ),

                  value: args.usernameTextField
                })}
                {p.renderPlasmicSlot({
                  defaultContents: (
                    <TextField
                      className={classNames(
                        "__wab_instance",
                        sty.materialUiTextField__jf908
                      )}
                      label={"Password" as const}
                    />
                  ),

                  value: args.passwordTextField
                })}
              </p.Stack>
            ) : null}
            {(hasVariant($state, "loading", "loading") ? true : false) ? (
              <div
                className={classNames(projectcss.all, sty.freeBox__m8B8G, {
                  [sty.freeBoxloading__m8B8G09Hv2]: hasVariant(
                    $state,
                    "loading",
                    "loading"
                  )
                })}
              >
                {(hasVariant($state, "loading", "loading") ? true : false) ? (
                  <CircularProgress
                    data-plasmic-name={"materialUiCircularProgress"}
                    data-plasmic-override={overrides.materialUiCircularProgress}
                    className={classNames(
                      "__wab_instance",
                      sty.materialUiCircularProgress,
                      {
                        [sty.materialUiCircularProgressloading]: hasVariant(
                          $state,
                          "loading",
                          "loading"
                        )
                      }
                    )}
                    size={
                      hasVariant($state, "loading", "loading")
                        ? (75 as const)
                        : undefined
                    }
                  />
                ) : null}
              </div>
            ) : null}
            {(hasVariant($state, "loading", "loading") ? true : true) ? (
              <button
                data-plasmic-name={"signInButton"}
                data-plasmic-override={overrides.signInButton}
                className={classNames(
                  projectcss.all,
                  projectcss.button,
                  projectcss.__wab_text,
                  sty.signInButton,
                  {
                    [sty.signInButtonloading]: hasVariant(
                      $state,
                      "loading",
                      "loading"
                    )
                  }
                )}
                ref={ref => {
                  $refs["signInButton"] = ref;
                }}
              >
                {"Sign in"}
              </button>
            ) : null}
            <img
              data-plasmic-name={"img"}
              data-plasmic-override={overrides.img}
              alt={""}
              className={classNames(projectcss.all, projectcss.img, sty.img)}
              src={imageGemkdHeh9}
            />
          </p.Stack>
        </p.Stack>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "welcome",
    "text",
    "materialUiCircularProgress",
    "signInButton",
    "img"
  ],
  welcome: ["welcome"],
  text: ["text"],
  materialUiCircularProgress: ["materialUiCircularProgress"],
  signInButton: ["signInButton"],
  img: ["img"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  welcome: "div";
  text: "div";
  materialUiCircularProgress: typeof CircularProgress;
  signInButton: "button";
  img: "img";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicLoginPage__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicLoginPage__VariantsArgs;
    args?: PlasmicLoginPage__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicLoginPage__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicLoginPage__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicLoginPage__ArgProps,
          internalVariantPropNames: PlasmicLoginPage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicLoginPage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicLoginPage";
  } else {
    func.displayName = `PlasmicLoginPage.${nodeName}`;
  }
  return func;
}

export const PlasmicLoginPage = Object.assign(
  // Top-level PlasmicLoginPage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    welcome: makeNodeComponent("welcome"),
    text: makeNodeComponent("text"),
    materialUiCircularProgress: makeNodeComponent("materialUiCircularProgress"),
    signInButton: makeNodeComponent("signInButton"),
    img: makeNodeComponent("img"),

    // Metadata about props expected for PlasmicLoginPage
    internalVariantProps: PlasmicLoginPage__VariantProps,
    internalArgProps: PlasmicLoginPage__ArgProps,

    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicLoginPage;
/* prettier-ignore-end */
